import { fromJS } from "immutable";
import INCIDENT_ACTIONS from "../actions/incident.actions";

const initialState = fromJS({
  // List
  incidentList: null,
  incidentListLoading: false,
  incidentListError: "",

  // Dashboard
  incidentDashboard: null,
  incidentDashboardLoading: false,
  incidentDashboardError: "",

  // Detail
  incidentDetail: null,
  incidentDetailLoading: false,
  incidentDetailError: "",

  // Create
  incidentCreateLoading: false,
  incidentCreateError: "",
  incidentCreateSuccess: false,
  createdIncident: null,

  // Update
  incidentUpdateLoading: false,
  incidentUpdateError: "",
  incidentUpdateSuccess: false,
  updatedIncident: null,

  // Investigate
  incidentInvestigateLoading: false,
  incidentInvestigateError: "",
  incidentInvestigateSuccess: false,

  // Close
  incidentCloseLoading: false,
  incidentCloseError: "",
  incidentCloseSuccess: false,

  // Close Draft
  incidentCloseDraftLoading: false,
  incidentCloseDraftError: "",
  incidentCloseDraftSuccess: false,

  // Delete
  incidentDeleteLoading: false,
  incidentDeleteError: "",
  incidentDeleteSuccess: false,

  // Export
  incidentExportLoading: false,
  incidentExportError: "",

  // Assigned Participants
  assignedParticipants: null,
  assignedParticipantsLoading: false,
  assignedParticipantsError: "",

  // Bulk PDF Generate
  bulkPdfGenerateLoading: false,
  bulkPdfGenerateError: "",
  bulkPdfGenerateSuccess: null,
});

export default function incidentReducer(state = initialState, action) {
  switch (action.type) {
    // List
    case INCIDENT_ACTIONS.INCIDENT_LIST.PENDING:
      return state.set("incidentListLoading", true).set("incidentListError", "");
    case INCIDENT_ACTIONS.INCIDENT_LIST.SUCCESS:
      return state
        .set("incidentListLoading", false)
        .set("incidentListError", "")
        .set("incidentList", action.data);
    case INCIDENT_ACTIONS.INCIDENT_LIST.ERROR:
      return state
        .set("incidentListLoading", false)
        .set("incidentListError", action.error);

    // Dashboard
    case INCIDENT_ACTIONS.INCIDENT_DASHBOARD.PENDING:
      return state
        .set("incidentDashboardLoading", true)
        .set("incidentDashboardError", "");
    case INCIDENT_ACTIONS.INCIDENT_DASHBOARD.SUCCESS:
      return state
        .set("incidentDashboardLoading", false)
        .set("incidentDashboardError", "")
        .set("incidentDashboard", action.data);
    case INCIDENT_ACTIONS.INCIDENT_DASHBOARD.ERROR:
      return state
        .set("incidentDashboardLoading", false)
        .set("incidentDashboardError", action.error);

    // Detail
    case INCIDENT_ACTIONS.INCIDENT_DETAIL.PENDING:
      return state
        .set("incidentDetailLoading", true)
        .set("incidentDetailError", "");
    case INCIDENT_ACTIONS.INCIDENT_DETAIL.SUCCESS:
      return state
        .set("incidentDetailLoading", false)
        .set("incidentDetailError", "")
        .set("incidentDetail", action.data);
    case INCIDENT_ACTIONS.INCIDENT_DETAIL.ERROR:
      return state
        .set("incidentDetailLoading", false)
        .set("incidentDetailError", action.error);

    // Create
    case INCIDENT_ACTIONS.INCIDENT_CREATE.PENDING:
      return state
        .set("incidentCreateLoading", true)
        .set("incidentCreateError", "")
        .set("incidentCreateSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_CREATE.SUCCESS:
      return state
        .set("incidentCreateLoading", false)
        .set("incidentCreateError", "")
        .set("incidentCreateSuccess", true)
        .set("createdIncident", action.data);
    case INCIDENT_ACTIONS.INCIDENT_CREATE.ERROR:
      return state
        .set("incidentCreateLoading", false)
        .set("incidentCreateError", action.error)
        .set("incidentCreateSuccess", false);

    // Update
    case INCIDENT_ACTIONS.INCIDENT_UPDATE.PENDING:
      return state
        .set("incidentUpdateLoading", true)
        .set("incidentUpdateError", "")
        .set("incidentUpdateSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_UPDATE.SUCCESS:
      return state
        .set("incidentUpdateLoading", false)
        .set("incidentUpdateError", "")
        .set("incidentUpdateSuccess", true)
        .set("updatedIncident", action.data)
        // CRITICAL: Also update incidentDetail to keep it in sync
        // This fixes the bug where outcome_type changes weren't persisting
        // because incidentDetail retained stale data after updates
        .set("incidentDetail", action.data);
    case INCIDENT_ACTIONS.INCIDENT_UPDATE.ERROR:
      return state
        .set("incidentUpdateLoading", false)
        .set("incidentUpdateError", action.error)
        .set("incidentUpdateSuccess", false);

    // Investigate
    case INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.PENDING:
      return state
        .set("incidentInvestigateLoading", true)
        .set("incidentInvestigateError", "")
        .set("incidentInvestigateSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.SUCCESS:
      return state
        .set("incidentInvestigateLoading", false)
        .set("incidentInvestigateError", "")
        .set("incidentInvestigateSuccess", true)
        .set("incidentDetail", action.data);
    case INCIDENT_ACTIONS.INCIDENT_INVESTIGATE.ERROR:
      return state
        .set("incidentInvestigateLoading", false)
        .set("incidentInvestigateError", action.error)
        .set("incidentInvestigateSuccess", false);

    // Close
    case INCIDENT_ACTIONS.INCIDENT_CLOSE.PENDING:
      return state
        .set("incidentCloseLoading", true)
        .set("incidentCloseError", "")
        .set("incidentCloseSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_CLOSE.SUCCESS:
      return state
        .set("incidentCloseLoading", false)
        .set("incidentCloseError", "")
        .set("incidentCloseSuccess", true)
        .set("incidentDetail", action.data);
    case INCIDENT_ACTIONS.INCIDENT_CLOSE.ERROR:
      return state
        .set("incidentCloseLoading", false)
        .set("incidentCloseError", action.error)
        .set("incidentCloseSuccess", false);

    // Close Draft
    case INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.PENDING:
      return state
        .set("incidentCloseDraftLoading", true)
        .set("incidentCloseDraftError", "")
        .set("incidentCloseDraftSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.SUCCESS:
      return state
        .set("incidentCloseDraftLoading", false)
        .set("incidentCloseDraftError", "")
        .set("incidentCloseDraftSuccess", true);
    case INCIDENT_ACTIONS.INCIDENT_CLOSE_DRAFT.ERROR:
      return state
        .set("incidentCloseDraftLoading", false)
        .set("incidentCloseDraftError", action.error)
        .set("incidentCloseDraftSuccess", false);

    // Delete
    case INCIDENT_ACTIONS.INCIDENT_DELETE.PENDING:
      return state
        .set("incidentDeleteLoading", true)
        .set("incidentDeleteError", "")
        .set("incidentDeleteSuccess", false);
    case INCIDENT_ACTIONS.INCIDENT_DELETE.SUCCESS:
      return state
        .set("incidentDeleteLoading", false)
        .set("incidentDeleteError", "")
        .set("incidentDeleteSuccess", true);
    case INCIDENT_ACTIONS.INCIDENT_DELETE.ERROR:
      return state
        .set("incidentDeleteLoading", false)
        .set("incidentDeleteError", action.error)
        .set("incidentDeleteSuccess", false);

    // Export
    case INCIDENT_ACTIONS.INCIDENT_EXPORT.PENDING:
      return state
        .set("incidentExportLoading", true)
        .set("incidentExportError", "");
    case INCIDENT_ACTIONS.INCIDENT_EXPORT.SUCCESS:
      return state
        .set("incidentExportLoading", false)
        .set("incidentExportError", "");
    case INCIDENT_ACTIONS.INCIDENT_EXPORT.ERROR:
      return state
        .set("incidentExportLoading", false)
        .set("incidentExportError", action.error);

    // Assigned Participants
    case INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.PENDING:
      return state
        .set("assignedParticipantsLoading", true)
        .set("assignedParticipantsError", "");
    case INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.SUCCESS:
      return state
        .set("assignedParticipantsLoading", false)
        .set("assignedParticipantsError", "")
        .set("assignedParticipants", action.data);
    case INCIDENT_ACTIONS.GET_ASSIGNED_PARTICIPANTS.ERROR:
      return state
        .set("assignedParticipantsLoading", false)
        .set("assignedParticipantsError", action.error);

    // Bulk PDF Generate
    case INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.PENDING:
      return state
        .set("bulkPdfGenerateLoading", true)
        .set("bulkPdfGenerateError", "")
        .set("bulkPdfGenerateSuccess", null);
    case INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.SUCCESS:
      return state
        .set("bulkPdfGenerateLoading", false)
        .set("bulkPdfGenerateError", "")
        .set("bulkPdfGenerateSuccess", action.data);
    case INCIDENT_ACTIONS.INCIDENT_BULK_PDF_GENERATE.ERROR:
      return state
        .set("bulkPdfGenerateLoading", false)
        .set("bulkPdfGenerateError", action.error)
        .set("bulkPdfGenerateSuccess", null);

    // Reset
    case INCIDENT_ACTIONS.INCIDENT_RESET_DETAIL:
      return state
        .set("incidentDetail", null)
        .set("incidentDetailLoading", false)
        .set("incidentDetailError", "");
    case INCIDENT_ACTIONS.INCIDENT_RESET_CREATE:
      return state
        .set("incidentCreateSuccess", false)
        .set("incidentCreateError", "")
        .set("createdIncident", null);

    case INCIDENT_ACTIONS.INCIDENT_RESET_DELETE:
      return state
        .set("incidentDeleteSuccess", false)
        .set("incidentDeleteError", "");

    case INCIDENT_ACTIONS.INCIDENT_RESET_INVESTIGATE:
      return state
        .set("incidentInvestigateSuccess", false)
        .set("incidentInvestigateError", "")
        .set("incidentInvestigateLoading", false);

    case INCIDENT_ACTIONS.INCIDENT_RESET_CLOSE:
      return state
        .set("incidentCloseSuccess", false)
        .set("incidentCloseError", "")
        .set("incidentCloseLoading", false);

    case INCIDENT_ACTIONS.INCIDENT_RESET_CLOSE_DRAFT:
      return state
        .set("incidentCloseDraftSuccess", false)
        .set("incidentCloseDraftError", "")
        .set("incidentCloseDraftLoading", false);

    case INCIDENT_ACTIONS.INCIDENT_RESET_BULK_PDF_GENERATE:
      return state
        .set("bulkPdfGenerateSuccess", null)
        .set("bulkPdfGenerateError", "")
        .set("bulkPdfGenerateLoading", false);

    default:
      return state;
  }
}
